import { createApp } from 'vue'
import App from './App.vue'

// Extending JavaScript strings with basic functionality
String.prototype.capitalize = function () {
    return `${this.charAt(0).toUpperCase()}${this.slice(1)}`;
};

createApp(App).mount('#app')
